import React from 'react'

import ServicesPage from './services-page'

export default function Services() {
    return <ServicesPage />
}
